import React, { FC } from 'react'

const NoPage: FC = () => {
    return (
        <div className='no_page'>
            <div className='logo'>
                <h1>404</h1>
                <p>The Page not Found-找不到你要访问的页面</p>
                <div className='sub'>
                    <p>
                        <a href="/">返回首页</a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default NoPage